<script setup lang="ts">
const {
  disabled = false,
} = defineProps<{ disabled?: boolean }>()

const model = defineModel({
  default: false,
})
</script>

<template>
  <div class="relative inline-flex items-center">
    <input
      v-model="model"
      type="checkbox"
      :disabled="disabled"
      class="peer sr-only"
    />
    <div
      class="w-5 h-5 flex justify-center items-center peer-checked:bg-[--theme-lighter] rounded peer-focus:border-[--theme-light] peer-focus:ring-[--theme-light] peer-focus:ring-1"
      :class="{
        'border-2 border-[--theme-lightest]': !model,
        'hover:bg-[--theme-lighter] hover:border-none': !disabled,
      }"
    >
      <UIcon v-if="model" name="check" class="text-black" size="xxs" />
    </div>
  </div>
</template>
